import { Link, useNavigate } from "react-router-dom";
import AuthLayout from "../../layouts/AuthLayout";
import Field from "../../components/Field";
import styles from "./RequestAccessPage.module.css";
import { useRequestAccessForm } from "./useRequestAccessForm";

export default function RequestAccessPage() {
  const navigate = useNavigate();
  const { values, errors, canSubmit, submittedOnce, setField, onSubmit, isLoading, formError } =
    useRequestAccessForm({
      onSuccess: () => navigate("/console", { replace: true })
    });

  return (
    <AuthLayout>
      <h2 className={styles.title}>Create Account</h2>

      <p className={styles.subtitle}>
        Already have an account?{" "}
        <Link to="/">Login</Link>
      </p>

      <form className={styles.form} onSubmit={onSubmit} noValidate>
        {formError ? <div className={styles.formError}>{formError}</div> : null}

        <Field
          label="Full name*"
          placeholder="First and last name"
          value={values.fullName}
          onChange={(v) => setField("fullName", v)}
          error={errors.fullName}
          name="fullName"
          autoComplete="name"
          disabled={isLoading}
        />

        <Field
          label="Company name*"
          placeholder="Company name"
          value={values.companyName}
          onChange={(v) => setField("companyName", v)}
          error={errors.companyName}
          rightIcon
          name="companyName"
          autoComplete="organization"
          disabled={isLoading}
        />

        <Field
          label="Company email*"
          placeholder="hello@ridebasecloud.com"
          value={values.companyEmail}
          onChange={(v) => setField("companyEmail", v)}
          error={errors.companyEmail}
          rightIcon
          inputMode="email"
          type="email"
          name="companyEmail"
          autoComplete="email"
          disabled={isLoading}
        />

        <Field
          label="Password*"
          placeholder="At least 6 characters"
          value={values.password}
          onChange={(v) => setField("password", v)}
          error={errors.password}
          type="password"
          name="password"
          autoComplete="new-password"
          disabled={isLoading}
        />

        <Field
          label="Confirm password*"
          placeholder="Re-enter your password"
          value={values.confirmPassword}
          onChange={(v) => setField("confirmPassword", v)}
          error={errors.confirmPassword}
          type="password"
          name="confirmPassword"
          autoComplete="new-password"
          disabled={isLoading}
        />

        <label className={styles.checkboxRow}>
          <input
            type="checkbox"
            checked={values.keepLoggedIn}
            onChange={(e) => setField("keepLoggedIn", e.target.checked)}
            disabled={isLoading}
          />
          <span>Keep me logged in</span>
        </label>

        <div className={styles.notice}>
          Use your company or .edu email for instant access
        </div>

        <button
          className={styles.primaryBtn}
          type="submit"
          disabled={isLoading || (!canSubmit && submittedOnce)}
        >
          {isLoading ? "Creating Account..." : "Create Account"}
        </button>

        <p className={styles.footerLink}>
          Already have an account?{" "}
          <Link to="/">Login</Link>
        </p>

        <p className={styles.legal}>
          2025 Ridebase Mobility Systems LLC, All rights Reserved
        </p>
      </form>
    </AuthLayout>
  );
}